import { _, React, withStyles, StyledProps, moment } from '@api'
import {CustomAttributeDefinition} from '@api/graphql';
import { Theme, Typography, InputAdornment, FormControlLabel, Checkbox } from '@material-ui/core'
import { Add, ArrowDropDown } from '@material-ui/icons'
import { Chip, TextInput, CheckboxInput, SecondaryButton, PrimaryIconButton } from 'centric-ui-components'

const styles = (theme: Theme) => ({
  disabled: {
    color: 'rgba(27, 27, 27, 0.87)',
    fontSize: 14,
    '&:before': {
      borderBottom: '0 !important'
    }
  },
  tagTypes: {
    margin: `0 0 ${theme.spacing() * 3}px 0`
  },
  selectOption: {
    width: '256px'
  },
  body2: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontWeight: 'normal'
  },
  container: {
    marginBottom: theme.spacing() * 3
  },
  tagAttribute: {
    fontSize: '14px',
    color: 'transparent',
    textShadow: '0 0 0 #000'
  },
  button: {
    width: '100%',
    height: 60,
    borderRadius: 2,
    backgroundColor: '#f5f5f5',
    color: 'rgba(27, 27, 27, 0.38)',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    marginBottom: '8px'
  },
  tagList: {
    margin: '0px 0px'
  },
  checkbox: {
    alignItems: 'end',  
    marginBottom: 15

  },

  paddingCheckbox: {
    padding: '0px 12px 12px 12px'
  }
})

interface TagTypes {
  id?: string
  tags?: Array<{ name: string }>
}

interface DisplayName {
  id?: string
  singular?: string
  plural?: string
}

export interface ITag {
  id?: string
  name?: string
}

interface Attributes {
  strVal?: string,
  name?: string,
  strList?: Array<{ id: string, name: string }>,
  tag?: ITag,
  floatVal?: string,
  customAttributeDefinition?: CustomAttributeDefinition
  tagList?: Array<{ id: string, name: string }>
  id?: string
  boolList?: Array<{ id: string, name: string }>
  boolVal?: boolean
  floatList?: Array<{ id: string, name: string }>
  intVal?: boolean
  intList?: Array<{ id: string, name: string }>
  dateTimeVal?: Date
}

interface Field {
  field?: string
  type?: string
  label?: string
  model?: string
  isEditable?: boolean
}

interface MyProps extends StyledProps {
  attributes?: Array<Attributes>,
  attributeDefinition: CustomAttributeDefinition
  attribute?: any
  field: Field,
  onChangeInput?: (e, f, isCustom, updateSpec?) => void,
  onClickAddTag?: (e, data) => void,
  onChipDelete?: (e, id, attrDef, updateSpec?) => void
  editMode?: boolean,
  name?: string,
  options?: any
  saveCustomAttribute?: (updateSpec, model, value) => void
  updateSpec?: any
}

export class CustomAttributeComponent extends React.Component<MyProps> {
  typeMap = {
    String: 'strVal',
    Int: 'intVal',
    Float: 'floatVal',
    Boolean: 'boolVal',
    Tag: 'tag',
    TagList: 'tagList',
    DateTime: 'dateTimeVal'
  }

  static defaultProps = {
    field: {}
  }

  render() {
    const {
      props: {
        attributes,
        attribute,
        attributeDefinition,
        classes,
        field,
        onChangeInput,
        onClickAddTag,
        onChipDelete,
        editMode,
        saveCustomAttribute,
        updateSpec,
      }
    } = this
    if (_.isEmpty(field)) {
      const type = attributeDefinition ? attributeDefinition.type : null
      const label = attributeDefinition?.displayName?.singular ?? attributeDefinition.name
      let value = attribute
      const valueField = type && this.typeMap[type]
      switch (type) {
        case 'Int':
        case 'String':
        case 'Float':
          return <TextInput
            label={label}
            value={(!_.isUndefined(value) && !_.isNull(value) && value.toLocaleString()) || (value == '' ?editMode? '':value : '--')}
            placeholder={editMode?`Enter ${label}`:''}
            disabled={!editMode}
            name={attributeDefinition.name}
            InputProps={{
              classes: { disabled: classes.disabled }
            }}
            onBlur={(e) => saveCustomAttribute && saveCustomAttribute(updateSpec, attributeDefinition.name, value)}
            onChange={(e) => { onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }) : null }}
          />
        case 'Boolean':
          return <CheckboxInput
            label={label}
            checkboxCss={classes.paddingCheckbox}
            className={classes.checkbox}
            checked={value === null ? false : value}
            disabled={!editMode}
            name={attributeDefinition.name}
            onChange={(e) => { onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }, updateSpec) : null }}
          />
        case 'Tag':
          if (!value) {
            value = {
              name: '',
              id: ''
            }
          }

          const disabled = !editMode
          return (<TextInput
            inputProps={{
              className: classes.tagAttribute
            }}
            name={`custom-${label}`}
            label={label}
            fullWidth
            value={value ? value : disabled ? '--' : ''}
            disabled={disabled}
            onClick={(e) => { disabled ? null : onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }}
            InputProps={{
              endAdornment: !disabled ? <InputAdornment position="end"><ArrowDropDown /></InputAdornment> : null,
              classes: { disabled: classes.disabled }
            }}
          />)
        case 'TagList':
          const tagList = attribute ? attribute.tagList : []
          const pluralLabel = attributeDefinition && attributeDefinition.displayName ? (attributeDefinition.displayName.plural || (attribute && attribute.name)) : attribute && attribute.name
          const chips = _.map(tagList, (tag, tagIndex) => (
            <Chip key={tagIndex} label={tag.name} onClickDelete={(e) => { editMode && onChipDelete && onChipDelete(e, tag.id, attributeDefinition, updateSpec) }} />
          ))
          return <div className={classes.tagList}>
            {((chips && chips.length > 0) || !editMode) && <Typography classes={{ body1: classes.body2 }} variant={'body1'}>{label}</Typography>}
            <div className={classes.tagList}>
              {chips && chips.length ? chips : !(editMode) ? '--' : null}

              {editMode
                ? chips.length > 0
                  ? <PrimaryIconButton onClick={(e) => { onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }} icon={<Add />} />
                  : <SecondaryButton onClick={(e) => { editMode && onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }} classes={{ root: classes.button }}>{`Add ${pluralLabel}`}</SecondaryButton>
                : null
              }
            </div>
          </div>
        case 'DateTime':
          return <TextInput
            label={label}
            value={(value === null || value === undefined || value === '') ? editMode ? '' : '--' : moment(value.name).format('MM/DD/YYYY')}
            placeholder={`Enter ${label}`}
            disabled={!editMode}
            name={attributeDefinition.name}
            InputProps={{
              classes: { disabled: classes.disabled }
            }}
            onBlur={(e) => saveCustomAttribute && saveCustomAttribute(updateSpec, attributeDefinition.name, value)}
            onChange={(e) => { onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }) : null }}
          />
        default:
          return null
      }
    } else {
      const fieldAttribute = _.find(attributes, attr => attr.name === field.model)
      const customAttributeType = !_.isEmpty(attributeDefinition) ? attributeDefinition.type : ''
      const valueField = customAttributeType && this.typeMap[customAttributeType]
      switch (customAttributeType) {
        case 'Int':
        case 'String':
        case 'Float':
          let value = fieldAttribute ? fieldAttribute[valueField] : ''
          if ((!field.isEditable || !editMode) && (value === '' || value === null || value === undefined)) {
            value = '--'
          }
          return <TextInput
            name={field.model}
            label={field.label ? field.label : ''}
            value={value.toString()}
            placeholder={`Enter ${field.label}`}
            disabled={!field.isEditable || !editMode}
            InputProps={{
              classes: { disabled: classes.disabled }
            }}
            onBlur={(e) => saveCustomAttribute && saveCustomAttribute(updateSpec, field.model, value)}
            onChange={(e) => { onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }) : null }}
          />
        case 'Boolean':
          return <CheckboxInput
            name={field.model}
            label={field.label}
            checked={fieldAttribute ? fieldAttribute.boolVal === true : false}
            onChange={(e) => {
              onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }, updateSpec) : null
            }}
            disabled={!field.isEditable || !editMode}
          />
        case 'Tag':
          const tag = fieldAttribute ? fieldAttribute.tag : null
          const disabled = !field.isEditable || !editMode
          return (<TextInput
            inputProps={{
              className: classes.tagAttribute
            }}
            name={'sample'}
            label={field.label}
            fullWidth
            value={tag && tag.name ? tag.name : disabled ? '--' : ''}
            disabled={disabled}
            onClick={(e) => { disabled ? null : onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }}
            InputProps={{
              endAdornment: !disabled ? <InputAdornment position="end"><ArrowDropDown /></InputAdornment> : null,
              classes: { disabled: classes.disabled }
            }}
          />)
        case 'TagList':
          const tagList = fieldAttribute ? fieldAttribute.tagList : []
          const isEditable = field.isEditable && editMode
          const chips = _.map(tagList, (tag, tagIndex) => (
            <Chip key={tagIndex} label={tag.name} onClickDelete={(e) => { editMode && onChipDelete && onChipDelete(e, tag.id, attributeDefinition, updateSpec) }} />
          ))
          return <div className={classes.tagList}>
            {((chips && chips.length > 0) || !(isEditable)) && <Typography classes={{ body1: classes.body2 }} variant={'body1'}>{field.label}</Typography>}
            <div className={classes.tagList}>
              {chips && chips.length ? chips : !(isEditable) ? '--' : null}
              {isEditable
                ? chips.length > 0
                  ? <PrimaryIconButton onClick={(e) => { onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }} icon={<Add />} />
                  : <SecondaryButton onClick={(e) => { editMode && onClickAddTag && onClickAddTag(e, { definition: attributeDefinition, valueField }) }} classes={{ root: classes.button }}>{`Add ${field.label}`}</SecondaryButton>
                : null
              }
            </div>
          </div>
        case 'DateTime':
          if ((!field.isEditable || !editMode) && (value === '' || value === null || value === undefined)) {
            value = '--'
          }
          return <TextInput
            name={field.model}
            label={field.label ? field.label : ''}
            value={fieldAttribute && fieldAttribute.dateTimeVal ? moment(fieldAttribute.dateTimeVal as any).format('MM/DD/YYYY') : ''}
            placeholder={`Enter ${field.label}`}
            disabled={!field.isEditable || !editMode}
            InputProps={{
              classes: { disabled: classes.disabled }
            }}
            onBlur={(e) => saveCustomAttribute && saveCustomAttribute(updateSpec, field.model, value)}
            onChange={(e) => { onChangeInput ? onChangeInput(e, true, { definition: attributeDefinition, valueField }) : null }}
          />
        default:
          return ''
      }
    }
  }
}

@(withStyles as any)(styles)
export class CustomAttribute extends CustomAttributeComponent { }



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/CustomAttribute.tsx